import { ASSOCIATE_CART_WITH_USER_ERROR, ASSOCIATE_CART_WITH_USER_REQUEST, ASSOCIATE_CART_WITH_USER_SUCCESS, } from '../types';
export const associateCartRequest = () => {
    return {
        type: ASSOCIATE_CART_WITH_USER_REQUEST,
    };
};
export const associateCartSuccess = (cart) => {
    return {
        type: ASSOCIATE_CART_WITH_USER_SUCCESS,
        data: cart,
    };
};
export const associateCartError = (error) => {
    return {
        type: ASSOCIATE_CART_WITH_USER_ERROR,
        error: true,
        payload: error,
    };
};
export const associateCartWithUser = () => {
    return async (dispatch, getState, { chord }) => {
        const { auth, cart } = getState();
        if (!auth.token) {
            throw new Error('Cannot associate cart with user, user is not logged in');
        }
        if (!cart.data.id) {
            throw new Error('Cannot associate cart with user, cart is not found');
        }
        try {
            dispatch(associateCartRequest());
            const newCart = await chord.oms.associateOrderWithUser(cart.data, auth.token);
            dispatch(associateCartSuccess(newCart));
        }
        catch (error) {
            dispatch(associateCartError(error));
            throw error;
        }
    };
};
